import {UnstableCard as Paper} from '@logistics-frontend/blocks'
import React from 'react'

import {AddressProvider} from '../../contexts/AddressContext'
import {renderWidget} from '..'
import {FormWidgetConfig} from '../types'
import * as classes from './Form.classes'

export const FormWidget = ({header_section, sections, bottom_section}: FormWidgetConfig): React.ReactElement => {
  return (
    <AddressProvider>
      {header_section && (
        <Paper className={classes.headerSection} padding="none" radius="L" noOverflow>
          {header_section.widgets.map(renderWidget)}
        </Paper>
      )}
      {sections.map(section => (
        <Paper className={classes.bodySection} radius="L" noOverflow>
          {section.widgets.map(renderWidget)}
        </Paper>
      ))}
      <div className={classes.bottomSectionWrapper}>{bottom_section && bottom_section.widgets.map(renderWidget)}</div>
    </AddressProvider>
  )
}
